export enum TEAM_TYPE {
  HOME,
  AWAY,
}

export enum HOME_TEAM_SIDE {
  LEFT,
  RIGHT,
}

export type STAT_CATEGORY = "attack" | "defence" | "setball" | "foul";

export type IStatsValue =
  | "PASS"
  | "THROUGH"
  | "DRIBBLE"
  | "SHOOT"
  | "OFFSIDE"
  | "TACKLE"
  | "INTERCEPTION"
  | "BLOCK"
  | "CLEARANCE"
  | "SAVING"
  | "OWN_GOAL"
  | "FREE_KICK"
  | "CORNER_KICK"
  | "PENALTY"
  | "FOUL"
  | "YELLOW"
  | "RED";

export interface STAT_DATA {
  name: IStatsValue;
  i18nTag: string;
  category: STAT_CATEGORY;
  shortcutKey: string;
}

export interface STAT_VALUE {
  PASS: number;
  THROUGH: number;
  DRIBBLE: number;
  SHOOT: number;
  TACKLE: number;
  INTERCEPTION: number;
  BLOCK: number;
  CLEARANCE: number;
  OFFSIDE: number;
  SAVING: number;
  OWN_GOAL: number;
  FREE_KICK: number;
  CORNER_KICK: number;
  PENALTY: number;
  FOUL: number;
  YELLOW: number;
  RED: number;
}

export interface KeyMapMatcher {
  name: string;
  sequence: string;
}
